import React from 'react'
import TabsContainer from './TabsContainer'

const Tabs = props => <TabsContainer {...props} data-test="component-stock-vehicle-detail-tabs" />
export default Tabs
